import { render, staticRenderFns } from "./SlaEmptyState.vue?vue&type=template&id=0df76f35&scoped=true&"
import script from "./SlaEmptyState.vue?vue&type=script&lang=js&"
export * from "./SlaEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./SlaEmptyState.vue?vue&type=style&index=0&id=0df76f35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df76f35",
  null
  
)

export default component.exports